import { PopoverPosition as BlueprintPopoverPosition } from '@blueprintjs/core';
import { Information } from '@carbon/icons-react';
import classNames from 'classnames';
import * as React from 'react';

import { Icon } from 'bones/design-system/components/icons/Icon';
import { SystemMessage } from 'bones/design-system/components/notifications/SystemMessage';
import { Tooltip } from 'bones/design-system/components/Tooltip';

export interface SystemInfoProps {
  'data-testid'?: never;
  className?: string;
  testId?: string;
  text: string;
  position?: BlueprintPopoverPosition;
}

export const SystemInfo: React.VFC<SystemInfoProps> = ({
  className,
  testId,
  text,
  position = BlueprintPopoverPosition.TOP,
}) => (
  <Tooltip
    position={position}
    slot={<SystemMessage text={text} variant="info" />}
    targetProps={{ className: 'vb-system-info-popover-target' }}
  >
    <Icon
      className={classNames(className, 'vb-system-info')}
      IconComponent={Information}
      size="sm"
      testId={testId}
    />
  </Tooltip>
);
